module.exports = __webpack_public_path__ + "static/media/community_2.1548f941.svg";